
import { MipsQuestionnaire } from '@models/mips-stepper.model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const MipsQuestionnaireActions = createActionGroup({
  source: 'MipsQuestionnaire',
  events: {
    'Page Loaded': emptyProps(),

    'Validity Changed': props<{ validity: boolean }>(),

    'Submit MIPS Questionnaire': props<{ 
      mipsQuestionnaire: MipsQuestionnaire; 
      orgId: string; 
      performanceYear: number 
    }>(),
    'Submit MIPS Questionnaire Success': props<{ response: any }>(),
    'Submit MIPS Questionnaire Failure': props<{ error: string }>(),

    'Load MIPS Questionnaire': props<{ orgId: string; performanceYear: number }>(),
    'Load MIPS Questionnaire Success': props<{ data: MipsQuestionnaire }>(),
    'Load MIPS Questionnaire Failure': props<{ error: string }>(),

    'Update MIPS Questionnaire': props<{ 
      mipsQuestionnaire: MipsQuestionnaire; 
      orgId: string; 
      performanceYear: number 
    }>(),
    'Update MIPS Questionnaire Success': props<{ response: any }>(),
    'Update MIPS Questionnaire Failure': props<{ error: string }>(),

    'Export All Questionnaires': props<{ orgId: string; performanceYear: number }>(),
    'Export All Questionnaires Success': props<{ blob: Blob; filename: string }>(),
    'Export All Questionnaires Failure': props<{ error: string }>(),

    'Reset Form': emptyProps(),
  }
});